import { render, staticRenderFns } from "./OpcMunicipal.vue?vue&type=template&id=21127c45"
import script from "./OpcMunicipal.vue?vue&type=script&lang=js"
export * from "./OpcMunicipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports